import type { CSSProperties } from "react";

/**
 * A cabeça da Mestra — o ícone da Mestra Help. Mesmo traço do hub
 * (techia-hub, `lib/tecoIcone.js` → `mestra`). Pinta com `currentColor`,
 * então herda a cor de quem estiver em volta, como um ícone do lucide.
 *
 * A cabeça empasta em tamanho pequeno: desenha 30% maior que o box
 * (`scale`), o mesmo ajuste que o hub faz.
 */
const HEAD_PATH =
  "M43.89,21.06c-.15.74-.86,1.26-1.63,1.26h-21.61c-.99,0-1.77.88-1.57,1.88.15.74.86,1.26,1.63,1.26h10.13c.99,0,1.77.88,1.57,1.88-.15.74-.86,1.26-1.63,1.26h-4.69c-.99,0-1.77.88-1.57,1.88.15.74.86,1.26,1.63,1.26h8.29c.78,0,1.48.51,1.63,1.26.19,1-.59,1.88-1.57,1.88,0,0-5.28-.03-7.04,0-6.76.1-9.05,3.01-11.61,4.5-2.21,1.29-3.17-1.58-3.42-2.35-.46-1.4-1.17-1.83-2.65-1.59-.85.13-1.69.36-2.54.43-.48.04-.97.02-1.46-.06-.68-.11-1.31-.45-1.73-.98-.77-.98-.27-1.78-.11-2.63.12-.65-.02-1.26-.56-1.67-.89-.67-.93-1.07-.05-1.99-1.09-.25-1.01-.88-.69-1.71.28-.72.01-1.05-.76-1.27-.41-.12-.84-.23-1.21-.43-.59-.31-.77-1.05-.42-1.6.9-1.46,1.77-2.93,2.67-4.4.32-.52.33-1.05.21-1.64-.83-4.06-.06-7.63,2.14-10.69,1.5-2.08,3.8-4.41,8.13-5.78,2.9-.91,6.04-.58,9.07-.58h5.92c.99,0,1.77.87,1.57,1.88-.15.74-.86,1.26-1.63,1.26h-4.93c-.99,0-1.77.88-1.57,1.88.15.74.86,1.26,1.63,1.26h13.72c.99,0,1.77.88,1.57,1.88-.15.74-.86,1.26-1.63,1.26h-17.54c-.99,0-1.77.88-1.57,1.88.15.74.86,1.26,1.63,1.26h13.46c.99,0,1.77.88,1.57,1.88-.15.74-.85,1.26-1.63,1.26h-.52c-.99,0-1.77.88-1.57,1.88.15.74.86,1.26,1.63,1.26h9.73c.99,0,1.77.88,1.57,1.88h0Z";

export function MestraIcon({
  size = 16,
  className,
  style
}: {
  size?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      viewBox="0 0 44 40"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={{ scale: "1.3", ...style }}
    >
      <path d={HEAD_PATH}/>
    </svg>
  );
}
